import { Box } from "@chakra-ui/react";

import { StepDetailsBaseProps } from "../../models/StepDetailsBaseProps";

 
export const SummaryStep = (props: StepDetailsBaseProps) => {
    const {
        colorScheme = 'blue', 
        className,
        style,
        children,
        saveActiveStepState,
        stepsSavedState,
        title,
        description,
        stepIdx,
        selectedStepOptionValue, // the value of the selected option
        stepOptions,
      } = props;

    const renderStepContent = () =>  {
        console.log({...props});

        return (
            <>
                <h4>Summary Portfolio Items:</h4> 

                <Box px={0}>
                <>
                    <p></p>
                    <ul>
                        <li>item</li>
                        <li>item</li>
                        <li>item</li>
                        <li>item</li>
                    </ul>
                </>
                </Box>

            </>
        );
    }

    return renderStepContent()
 
}


